import { getErrorKind, assertNever } from './errorKind';
var GENERIC = 'ui-czna-authorities.error.generic';
/**
 * Proposal-side wording for a failed API call.
 *
 * Returns a message id and nothing else — callers format it with no values — so
 * every key reachable from here MUST be parameter-free. That is why
 * validation/unprocessable/server collapse into the generic message: their
 * useful content lives in a `{detail}` / `{status}` placeholder this signature
 * cannot fill, and a half-rendered "Server hlásí chybu (HTTP {status})" on
 * screen is worse than the plain sentence. (The proposal form handles the 422
 * validation payload separately — `parseValidationFailedError` in ProposalForm.)
 *
 * CZNA-591: `forbidden`, `unauthenticated` and `network` are the kinds where the
 * ADVICE differs, so they get their own sentence. 403 in particular used to read
 * "Zkuste to prosím znovu" — the one instruction guaranteed not to help.
 *
 * CZNA-1625: `timeout` too — neither "try again" nor "check your connection" is safe over an
 * action the server may already have carried out.
 */
export var messageIdForKind = function (kind) {
    switch (kind) {
        case 'conflict':
            return 'ui-czna-authorities.error.optimisticLockConflict';
        case 'notFound':
            return 'ui-czna-authorities.error.notFound';
        case 'forbidden':
            return 'ui-czna-authorities.error.forbidden';
        case 'unauthenticated':
            return 'ui-czna-authorities.error.unauthenticated';
        case 'network':
            return 'ui-czna-authorities.error.network';
        case 'timeout':
            // CZNA-1625 — the action may have been carried out: verify before repeating it.
            return 'ui-czna-authorities.error.timeout';
        case 'validation':
        case 'unprocessable':
        case 'server':
        case 'unknown':
            return GENERIC;
        default:
            return assertNever(kind);
    }
};
export var getProposalErrorMessageId = function (info) {
    return messageIdForKind(getErrorKind(info));
};
